import type { InputHTMLAttributes } from "react"
import { Input } from "./input"
import { Label } from "./label"

/**
 * The classes of every raw `<textarea>`, `<select>` and `<input>` (decision 0056): white, the 3:1 `line-field` border,
 * 14px (16px on a phone, so iOS does not zoom on focus), ink border on focus.
 */
export const fieldClass =
  "rounded-control border border-line-field bg-surface px-2.5 py-1.5 text-[14px] text-ink max-sm:text-[16px] focus:border-ink"

export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string
  label: string
}

export function Field({ id, label, ...props }: FieldProps) {
  return (
    <div className="grid gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input id={id} name={id} {...props} />
    </div>
  )
}
